const quizQuests = {
    "quests":{
        "1_1": {
            "selected_text": "Выбрано Москва",
            "success": false,
            "counsel_text": "Рекомендовано выбирать Подмосковье",
            "points": 0
        },
        "1_2": {
            "selected_text": "Выбрано Подмосковье",
            "success": true,
            "counsel_text": "Рекомендовано выбирать Подмосковье",
            "points": 10
        },
        "1_3": {
            "selected_text": "Выбрано Регионы",
            "success": false,
            "counsel_text": "Рекомендовано выбирать Подмосковье",
            "points": 0
        },
        "2_1": {
            "selected_text": "Выбрана сетка 12 × 24",
            "success": false,
            "counsel_text": "Рекомендовано выбирать 18 × 18",
            "points": 0
        },
        "2_2": {
            "selected_text": "Выбрана сетка 18×18",
            "success": true,
            "counsel_text": "Рекомендовано выбирать 18 × 18",
            "points": 10
        },
        "2_3": {
            "selected_text": "Выбрана сетка 6 × 12",
            "success": false,
            "counsel_text": "Рекомендовано выбирать 18 × 18",
            "points": 0
        },
        "3_1": {
            "selected_text": "Выбрано 5 метров",
            "success": false,
            "counsel_text": "Рекомендовано выбирать 8 метров",
            "points": 0
        },
        "3_2": {
            "selected_text": "Выбрано 8 метров",
            "success": true,
            "counsel_text": "Рекомендовано выбирать 8 метров",
            "points": 10
        },
        "3_3": {
            "selected_text": "Выбрано 12,4 метров",
            "success": false,
            "counsel_text": "Рекомендовано выбирать 8 метров",
            "points": 0
        },
        "4_1": {
            "selected_text": "Выбраны Металлические трубы",
            "success": false,
            "counsel_text": "Рекомендовано выбирать Железобетон",
            "points": 0
        },
        "4_2": {
            "selected_text": "Выбран Железобетон",
            "success": true,
            "counsel_text": "Рекомендовано выбирать Железобетон",
            "points": 10
        },
        "4_3": {
            "selected_text": "Выбран Мелкоштучный материал",
            "success": false,
            "counsel_text": "Рекомендовано выбирать Железобетон",
            "points": 0
        },
        "5_1": {
            "selected_text": "Выбрано 3  т/м<sup>2</sup>",
            "success": false,
            "counsel_text": "Рекомендовано выбирать 5 т/м<sup>2</sup>",
            "points": 0
        },
        "5_2": {
            "selected_text": "Выбрано 5 т/м<sup>2</sup>",
            "success": true,
            "counsel_text": "Рекомендовано выбирать 5 т/м<sup>2</sup>",
            "points": 10
        },
        "5_3": {
            "selected_text": "Выбрано 8 т/м<sup>2</sup>",
            "success": false,
            "counsel_text": "Рекомендовано выбирать 5 т/м<sup>2</sup>",
            "points": 0
        },
        "6_1": {
            "selected_text": "Выбран Встроенный в объем здания",
            "success": true,
            "counsel_text": "Рекомендовано выбирать Встроенный в объем здания",
            "points": 10
        },
        "6_2": {
            "selected_text": "Выбран Отдельный модульный блок на территории",
            "success": false,
            "counsel_text": "Рекомендовано выбирать Встроенный в объем здания",
            "points": 0
        },
        "6_3": {
            "selected_text": "Выбрано Аренда офисного помещения в бизнес-центре",
            "success": false,
            "counsel_text": "Рекомендовано выбирать Встроенный в объем здания",
            "points": 0
        },
        "7_1": {
            "selected_text": "Выбрано Базовые решения",
            "success": false,
            "counsel_text": "Рекомендовано выбирать «Про запас»",
            "points": 0
        },
        "7_2": {
            "selected_text": "Выбран «Про запас»",
            "success": true,
            "counsel_text": "Рекомендовано выбирать «Про запас»",
            "points": 10
        },
        "7_3": {
            "selected_text": "Выбрано Отложить",
            "success": false,
            "counsel_text": "Рекомендовано выбирать «Про запас»",
            "points": 0
        },
        "8_1": {
            "selected_text": "Выбран Продумать каждое проектное решение под технологию",
            "success": false,
            "counsel_text": "Рекомендовано выбирать Применяем решение уже проверенное на рынке",
            "points": 0
        },
        "8_2": {
            "selected_text": "Выбран Сначала построим, потом подумаем «для чего?»",
            "success": false,
            "counsel_text": "Рекомендовано выбирать Применяем решение уже проверенное на рынке",
            "points": 0
        },
        "8_3": {
            "selected_text": "Выбран Применяем решение уже проверенное на рынке",
            "success": true,
            "counsel_text": "Рекомендовано выбирать Применяем решение уже проверенное на рынке",
            "points": 10
        },
        "9_1": {
            "selected_text": "Выбраны Готовые модульные панели",
            "success": true,
            "counsel_text": "Рекомендовано выбирать Готовые модульные панели",
            "points": 10
        },
        "9_2": {
            "selected_text": "Выбран Индивидуальный дизайнерский подход",
            "success": false,
            "counsel_text": "Рекомендовано выбирать Готовые модульные панели",
            "points": 0
        },
        "9_3": {
            "selected_text": "Выбран Базовый бетон с последующей отделкой",
            "success": false,
            "counsel_text": "Рекомендовано выбирать Готовые модульные панели",
            "points": 0
        },
        "10_1": {
            "selected_text": "Выбрано 3 метра",
            "success": false,
            "counsel_text": "Рекомендовано выбирать 4 метра",
            "points": 0
        },
        "10_2": {
            "selected_text": "Выбрано 4 метра",
            "success": true,
            "counsel_text": "Рекомендовано выбирать 4 метра",
            "points": 10
        },
        "10_3": {
            "selected_text": "Выбрано 5 метров",
            "success": false,
            "counsel_text": "Рекомендовано выбирать 4 метра",
            "points": 0
        },
        "11_1": {
            "selected_text": "Выбрана Ручная",
            "success": false,
            "counsel_text": "Рекомендовано выбирать Гибридная",
            "points": 0
        },
        "11_2": {
            "selected_text": "Выбрана Гибридная",
            "success": true,
            "counsel_text": "Рекомендовано выбирать Гибридная",
            "points": 10
        },
        "11_3": {
            "selected_text": "Выбрана Полная роботизация",
            "success": false,
            "counsel_text": "Рекомендовано выбирать Гибридная",
            "points": 0
        },
        "12_1": {
            "selected_text": "Выбрано Определить место на ЗУ под дальнейшее расширение",
            "success": true,
            "counsel_text": "Рекомендовано выбирать Определить место на ЗУ под дальнейшее расширение",
            "points": 10
        },
        "12_2": {
            "selected_text": "Выбрано Застроить ЗУ по максимуму с запасом",
            "success": false,
            "counsel_text": "Рекомендовано выбирать Определить место на ЗУ под дальнейшее расширение",
            "points": 0
        },
        "12_3": {
            "selected_text": "Выбрано Предусмотреть всю площадь только под сегодняшние задачи",
            "success": false,
            "counsel_text": "Рекомендовано выбирать Определить место на ЗУ под дальнейшее расширение",
            "points": 0
        },
        "13_1": {
            "selected_text": "Выбран Внутренний контроль (самостоятельно)",
            "success": false,
            "counsel_text": "Рекомендовано выбирать Комбинированно",
            "points": 0
        },
        "13_2": {
            "selected_text": "Выбран Внешний аудитор",
            "success": false,
            "counsel_text": "Рекомендовано выбирать Комбинированно",
            "points": 0
        },
        "13_3": {
            "selected_text": "Выбран Комбинированно",
            "success": true,
            "counsel_text": "Рекомендовано выбирать Комбинированно",
            "points": 10
        }
    }
}